import script from "./ManageBillingV3.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBillingV3.vue?vue&type=script&setup=true&lang=js"

import "./ManageBillingV3.vue?vue&type=style&index=0&id=21525131&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21525131"]])

export default __exports__